import { Interceptor } from './core/interceptor';
import { ProjectsModule } from './modules/common/projects/projects.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { ScenarioComparisonModule } from './modules/common/scenario-comparison/scenario-comparison.module';
import { HelpTabComponent } from './modules/common/help-tab/help-tab.component';
import { BnNgIdleService } from 'bn-ng-idle';

@NgModule({ declarations: [
        AppComponent,
        HelpTabComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        SharedModule,
        ProjectsModule,
        ScenarioComparisonModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: Interceptor,
            multi: true
        },
        BnNgIdleService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
